// src/components/Dashboard.js
import React from "react";
import {
  Box,
  Heading,
  HStack,
  Grid,
  GridItem,
  useTheme,
  Button,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { VaccineStock } from "./dashboard/VacineStock";
import { VaccineStockExp } from "./dashboard/VacineStockExp";
import { VaccineOrdersStackedBar } from "./dashboard/VaccineOrdersStackedBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileLines,
  faFileSignature,
  faScrewdriverWrench,
  faSyringe,
  faCow,
} from "@fortawesome/free-solid-svg-icons";
import { ProductionAndDeliveryChart } from "./dashboard/ProductionAndDeliveryChart";
import { VaccineDemandPieChart } from "./dashboard/VaccineDemandPieChart";
import Header from "../components/Header";
import { LivestockAmountPieChart } from "./dashboard/LivestockAmountPieChart";

const VaccineUsageOverview = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      p={{ base: 4, md: 8, lg: 15 }} // Responsive padding
      m={{ base: 2, md: 4, lg: 15 }} // Responsive margin
      w="100%"
      overflowX="auto" // Handle horizontal overflow
    >
      <Box
        mb={5}
        borderRadius="full"
        w="100%"
        bgColor="iBlue.600"
        color="white"
        p={{ base: 2, md: 3 }} // Responsive padding
      >
        <HStack spacing={{ base: 3, md: 5 }} ml={5}>
          <FontAwesomeIcon
            icon={faCow}
            color="white"
            size={{ base: "lg", md: "xl" }} // Responsive icon size
          />
          <Heading
            as="h1"
            size={{ base: "sm", md: "md", lg: "lg" }} // Responsive heading size
            fontWeight="normal"
          >
            จำนวนปศุสัตว์แยกตามพื้นที่ปศุสัตว์เขต
          </Heading>
        </HStack>
      </Box>
      <Box w="full" p={{ base: 2, md: 5 }}>
        {/* Responsive Grid */}
        <Grid
          templateColumns={{
            base: "1fr", // 1 column on mobile
            md: "repeat(2, 1fr)", // 2 columns on tablet
            lg: "repeat(3, 1fr)", // 3 columns on desktop
          }}
          gap={{ base: 4, md: 6, lg: 10 }} // Responsive gap
          m={{ base: 2, md: 5 }}
        >
          {["โคนม", "โคเนื้อ", "กระบือ", "ไก่", "เป็ด", "สุกร"].map((type) => (
            <GridItem
              key={type}
              bg="white"
              p={{ base: 3, md: 4 }} // Responsive padding
              borderRadius="md"
              boxShadow="md"
            >
              <LivestockAmountPieChart livestockType={type} />
            </GridItem>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default VaccineUsageOverview;